<template>
  <JyPagebody :activatedLoad="reloadData">
    <el-form label-width="150px" :rules="rules" :model="editData" size="small" ref="editForm" class="d-flex flex-grow-1 overflow-y-auto flex-column p-4 bg-white">
      <el-row v-loading="loadedData" type="flex" class="flex-wrap">
        <form-item label="标题" prop="title" fill="4">
          <el-input v-model="editData.title"></el-input>
        </form-item>
        <form-item label="开始时间" prop="updatetime" fill="4">
          <el-date-picker
            v-model="editData.updatetime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择开始统计时间">
          </el-date-picker>
        </form-item>
        <form-item label="摘要" fill="4">
          <el-input type="textarea" v-model="editData.content" :autosize="{ minRows: 2, maxRows: 6 }"></el-input>
        </form-item>
      </el-row>
      <!-- <el-alert type="error">添加或修改单位投稿后，点击下方【确定更新】保存后生效！</el-alert> -->
      <div class="flex-grow-1">
        <el-table
          ref="grid"
          v-loading="loadedData" loading-text="努力加载中..."
          :data="itemList"
          style="width: 100%; height:100%"
          height="100%"
          row-key="id"
          :row-class-name="editRowClass"
          border stripe
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        >
          <el-table-column
            prop="name"
            label="投稿单位"
            width="280">
            <template v-slot="{row, $index}">
              <el-row type="flex" class="flex-wrap">
                <form-item v-if="$index == editIndex" label="" label-width="0" prop="item.name" :rules="rules.name" fill="4">
                  <el-input v-model="editItem.name"></el-input>
                </form-item>
                <div v-else>{{ row.name }}</div>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column
            prop="num"
            width="120"
            label="投稿数量">
            <template v-slot="{row, $index}">
              <el-row type="flex" class="flex-wrap">
                <form-item v-if="$index == editIndex" label="" label-width="0" prop="item.num" :rules="rules.num" fill="4">
                  <el-input v-model.number="editItem.num"></el-input>
                </form-item>
                <div v-else>{{ row.num }}</div>
              </el-row>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form>
    <div slot="footer">
      <JyButton type="info" @click="reloadData" icon="refresh" class="mr-3">刷新</JyButton>
      <!-- <JyButton type="primary" @click="addTougao" icon="plus" class="mr-3">添加投稿</JyButton>-->
      <JyButton type="success" @click="doSave" icon="check">保存设置</JyButton>
    </div>
    <TougaoAdd @save="reloadData" ref="tougaoAdd" />
  </JyPagebody>
</template>

<script>
import TougaoAdd from './tougao-add';
import tools from 'jyutils/tools';
import { generateId, deepCopy } from 'jyutils/utils';
export default {
  components: { TougaoAdd },
  mixins: [tools],
  data() {
    return {
      title:'投稿排名',
      loadedData: false,
      editIndex: -1,
      editItem: {},
      itemList: [],
      rules: {
        title: {required: true, message:'名称必填！'},
        updatetime: {required: true, message:'更新时间！'},
        name: {required: true, message:'请输入单位！'},
        num: {required: true, type:'integer', min:0, message:'请输入投稿数量！'},
      }
    }
  },
  computed: {
    defaultData() {
      return {id:null, title: null, updatetime:null, content:null};
    }
  },
  watch: {
  },
  methods: {
    reloadData() {
      this.loadedData = true;
      this.doGet({
        url: 'sys/tougao',
        okcb: (json) => {
          this.editData = Object.assign({}, json);
          this.itemList = this.editData.itemList;

          // set origin data for check modified
          this.setOriaData();
        },
        cb: () => {
          this.loadedData = false;
        }
      });
    },
    editRowClass({rowIndex}) {
      return this.editIndex == rowIndex ? 'edit_table_row' : '';
    },
    addTougao() {
      this.$refs.tougaoAdd.show(true);
    },
    doEdit(data, index) {
      this.editItem = Object.assign({}, data);
      this.$set(this.editData, 'item', this.editItem);
      this.editIndex = index;
    },
    doUpdate(data) {
      const validate = () => {
        return new Promise((resolve, reject) => {
          let count = 0, isend = true;
          this.$refs.editForm.validateField(['item.name', 'item.num'], (err) => {
            if (err) {
              isend = false;
            }
            count ++;
            // console.log(err, data)
          });
          if (count == 2) {
            isend ? resolve() : reject();
          }
        });
      }
      validate().then(() => {
        Object.assign(data, this.editItem);
        this.editIndex = -1;
      }).catch(() => {});
    },
    doCancel(data, index) {
      if (data.id < 0) {
        this.itemList.splice(index, 1);
        this.updateEditIndex(index);
      } else {
        this.editIndex = -1;
      }
    },
    doSave() {
      this.submitform().then(() => {
        let postData = deepCopy(this.editData);
        delete postData.item;
        // console.log(this.editData)
        postData.itemList.map(d => {
          if (d.id < 0) {
            d.id = null;
          }
        });
        this.saveLoading = true;
        this.doPost({
          url: 'sys/tougao/save',
          data: postData,
          okcb: () => {
            this.$message.success('保存成功！');
            this.reloadData();
          },
          cb: () => {
            this.saveLoading = false;
          }
        });
      })
      .catch(() => { });
    },
    doDel(data, index) {
      let cb = () => {
        if (data.id < 0) {
          this.doCancel(data, index);
        } else {
          this.doPost({
            url: 'sys/tougao/delItem/'+ data.id,
            okcb: () => {
              this.$message.success('删除成功!');
              this.itemList.splice(index, 1);
              this.updateEditIndex(index);
            }
          });
        }
      }
      this.msgbox('此操作将永久删除该信息, 是否继续?', () => {
        cb();
      });
    },
    updateEditIndex(index) {
      if (index == this.editIndex) {
        this.editIndex = -1;
      } else if (index < this.editIndex) {
        this.editIndex -= 1;
      }
    },
    addRoot() {
      let data = Object.assign({}, {id: 0 - generateId(), name:null, num:null});
      this.itemList.unshift(data);
      this.editItem = Object.assign({}, data);
      this.$set(this.editData, 'item', this.editItem);
      this.editIndex = 0;
    },
  }
}
</script>
<style lang="less" scoped>
.news-cate-form {
  .eg-icon {
    .flex-center();
    width:2.6rem;
    height:2.6rem;
    border-radius:50%;
    i {
      color:#fff;
    }
  }
  .upload-demo {
    width:100%;
    /deep/ .el-upload-list__item-name {
      width:130px;
    }
  }
}
</style>
